import React from 'react';
import classNames from 'classnames';
import Image from '../../elements/Image';

const Logo = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'brand',
    className
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <h1 className="m-0">
        <a href='#home'>
          <Image
            src={require('./../../../assets/images/logo.svg')}
            alt="Open"
            width={80} />
        </a>
      </h1>
    </div>
  );
}

export default Logo;